/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { createSlice } from '@reduxjs/toolkit'
import type { ResidentQuotes } from '@zcode/state-type'
import { createTypedPayloadReducer } from '../rent-research-shared'
import { RESIDENT_QUOTES_INITIAL_STATE, RESIDENT_QUOTES_SLICE_NAME } from './constants'

export const residentQuotesSlice = createSlice({
  name: RESIDENT_QUOTES_SLICE_NAME,
  initialState: RESIDENT_QUOTES_INITIAL_STATE,
  reducers: {
    clear: () => RESIDENT_QUOTES_INITIAL_STATE,
    receiveResidentQuotes: createTypedPayloadReducer<ResidentQuotes>(),
  },
})

export const { clear, receiveResidentQuotes } = residentQuotesSlice.actions
